import axios from 'axios';
import { baseURL, myEpikBaseURL, unifiedBaseURL } from './api';
import store from '../../store';
import utils from '../utils';
const url = require('url');

const apiVersion = 'v2';
export const path = process.env.REACT_APP_BASE_URL + '/api/';
class NumberService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = myEpik => {
    const urlObj = url.parse(document.location.href, true);
    // const dev =
    //   urlObj.href.indexOf('my.epik.io') !== -1 ||
    //   urlObj.href.indexOf('mytest.epik.io') !== -1 ||
    //   urlObj.href.indexOf('mytestapi.epik.io') !== -1;
    const { isBoxTab } = store.getState()?.UIState?.globals;

    // if (!dev) {
    //   return this.baseURL || NumberService.resourcePath || NumberService.baseURL;
    // }
    if (myEpik || global.myEpik === 'Yes') {
      return myEpikBaseURL;
    }
    if (global.myEpik === 'No') {
      if (!isBoxTab) return myEpikBaseURL;
      return unifiedBaseURL();
      // return this.baseURL || NumberService.resourcePath || NumberService.baseURL;
    }
    return this.baseURL || NumberService.resourcePath || NumberService.baseURL;
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  // POST /api/numbers
  async createNumber(number, type) {
    if (this.demo) {
      return Promise.resolve({});
    }
    // @TODO implement add number
    return Promise.resolve({ number, type });
  }

  // GET /api/numbers/?type=[TYPE]&target=company
  // "/api/v2/companies/{id}/userEmails"
  async getCompanyNumbers(
    id,
    uid = false,
    type = 'all',
    gflag = false,
    getDeleted = global.deleteMode,
  ) {
    if (this.demo) {
      return Promise.resolve([]);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${id}/userEmails?uid=${uid}&userType=${type}&gflag=${gflag}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getCompanyTollFreeNumbers(companyId) {
    if (this.demo) {
      return Promise.resolve([]);
    }
  
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
  
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/numbers/company/${companyId}/tollFreeNumbers`,
      { headers }
    );
  
    return data;
  }
  
  // GET /api/numbers/?type=[TYPE]
  // my.epik.io:3000/api/v2/companies/5c0fa292845f46059f1c1ce1/users/
  async getUserNumbers(paginateOptions, id) {
    if (this.demo) {
      return Promise.resolve([]);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/companies/${id}/users/`, {
      headers,
    });
    return data;
  }

  // GET /api/numbers/?type=[TYPE]&target=all
  // GET /api/v2/company/:id/numbers
  async getAllNumbers(paginateOptions, id = null, type = 'all', disablePaginate, carrier, tempDID) {
    if (this.demo) {
      return Promise.resolve([]);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const path = id === null ? '/numbers' : `/companies/${id}/numbers`;

    const options = this.getPaginateOptions(paginateOptions);

    const paginate = disablePaginate ? 'disablePaginate=true' : `paginateOptions=${options}`;
    var carrrierUrl = '';
    var tempDidUrl = '';
    if (carrier) carrrierUrl = '&carrier=' + carrier;
    if (tempDID) tempDidUrl = `&tempDID=${tempDID}`;
    const { data } =
      id === 'none'
        ? { data: [] }
        : await axios.get(
            `${this.getBaseURL()}${apiVersion}${path}?${paginate}&type=${type}${carrrierUrl}${tempDidUrl}`,
            {
              headers,
            },
          );

    return data;
  }

  // DELETE /api/numbers/:id
  async deleteNumber(numberID) {
    if (this.demo) {
      return Promise.resolve({});
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = axios.delete(`${this.getBaseURL()}/${numberID}`, { headers });
    return data;
  }

  // DELETE /api/numbers?type=[TYPE]&target=company
  async deleteCompanyNumbers(type = 'all') {
    if (this.demo) {
      return Promise.resolve({});
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = axios.delete(`${this.getBaseURL()}/?type=${type}&target=company`, { headers });
    return data;
  }

  // DELETE /api/numbers?type=[TYPE]&target=company
  async deleteAllNumbers(type = 'all') {
    if (this.demo) {
      return Promise.resolve({});
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = axios.delete(`${this.getBaseURL()}/?type=${type}&target=all`, { headers });
    return data;
  }

  // DELETE /api/numbers?type=[TYPE]
  async deleteUserNumbers(type = 'all') {
    if (this.demo) {
      return Promise.resolve({});
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = axios.delete(`${this.getBaseURL()}/?type=${type}`, { headers });
    return data;
  }

  // POST /api/numbers
  // localhost:3000/api/v2/users/5d8be40fedc4e7090804aebc/numbers
  async addNewNumber(number, id) {
    if (this.demo) {
      return Promise.resolve([...number]);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/users/${id}/numbers`,
      number,
      { headers },
    );
    return data;
  }
  async deleteNumberById(num, id) {
    if (this.demo) {
      return;
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(`${this.getBaseURL()}${apiVersion}/numbers/${id}`, {
      headers,
    });
    return data;
  }

  async addBulkNumber(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/numbers?bulkInsert=true`,
      body,
      { headers },
    );
    return data;
  }

  // PUT /api/v2/numbers/:id ---- Update Number
  async updateNumber(value) {
    const huntPorts = utils.removeNullish(value?.huntPorts);
    const withoutDash = utils.removeDashes(huntPorts);


    // value?.huntPorts.value?.huntPorts?.filter(e => e != null || e != undefined);
    // ?.map(item => item?.replace(' ', '-'));
    const number = {
      ...value,
      huntPorts: withoutDash
    };
    if (this.demo) {
      return Promise.resolve([...number]);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    console.info({
      baseURL: this.getBaseURL(global.vmail),
      globalvmail: global.vmail,
    });

    const { data } = await axios.put(
      `${this.getBaseURL(global.vmail)}${apiVersion}/numbers/${number._id}`,
      number,
      { headers },
    );
    return data;
  }


   // PUT /api/v2/numbers/update-bulk-numbers ---- Bulk Update Number
   async updateBulkNumbers(body) {
    console.log("updateBulkNumbers", body)
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    console.info({
      baseURL: this.getBaseURL(global.vmail),
      globalvmail: global.vmail,
    });

    const { data } = await axios.put(
      `${this.getBaseURL(global.vmail)}${apiVersion}/numbers/update-bulk-numbers`,
      body,
      { headers },
    );
    return data;
  }

  // PUT /api/v2/numbers/fix?numberId=:numberId&boxId=:boxId ---- Force Fix Number
  async forceFixNumber(nid, bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL(global.vmail)}${apiVersion}/numbers/fix?numberId=${nid}&boxId=${bid}`,
      body,
      { headers },
    );
    return data;
  }

  // GET /api/v2/numbers/:id  ----- get numbers by id
  async getNumberByID(id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/numbers/${id}`, {
      headers,
    });
    return data;
  }
  async getNumberFeaturesByID(id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL(true)}${apiVersion}/numbers/${id}/features`,
      {
        headers,
      },
    );
    return data;
  }
  async updateNumberFeaturesByID(id, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL(true)}${apiVersion}/numbers/${id}/features`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  // GET /api/v2/alarm-relay/box/:bid/alarmStatus?portNumber=:pid  ----- get Alarm Relay Status

  async getAlarmRelay(bid, portNumber) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/alarm-relay/box/${bid}/alarmStatus?portNumber=${portNumber}`,
      {
        headers,
      },
    );
    return data;
  }

  // /api/v2/numbers/forwardUri?epiId=asdasdsad&port=port 1
  async getForwardUri(obiNumber, portName, externaleAta) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const queryParams = obiNumber
      ? `?epiNumber=${obiNumber}&port=${portName}`
      : `?port=${portName}&externalATAID=${externaleAta}`;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/numbers/forwardUri${queryParams}`,
      { headers },
    );
    return data;
  }

  // .post /:id/greeting',
  async uploadFile(id, files) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL(global.vmail)}${apiVersion}/numbers/${id}/greeting`,
      files,
      { headers },
    );
    return data;
  }

  // GET /companies/:id/numbers/:number
  async filterByNumber(id, number, pagination, carrier) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(pagination);
    var carrierUrl = '';
    if (carrier) carrierUrl = '&carrier=' + carrier;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${id}/numbers/${number}?paginateOptions=${options}${carrierUrl}`,
      { headers },
    );
    return data;
  }

  async filterByEmail(number, pagination) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(pagination);

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/numbers/search?filter=email&value=${number}&paginateOptions=${options}`,
      { headers },
    );
    return data;
  }

  async updateObiByNumber(obiNumber, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/updateByNumber/${obiNumber}`,
      body,
      { headers },
    );
    return data;
  }

  async updateAtaByNumber(ataNumber, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/ata/${ataNumber}/updateATAAssignedNumber`,
      body,
      { headers },
    );
    return data;
  }

  async updateAtaByPortId(ataId, body, epikBoxUser, numId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/ata/${ataId}/update?epikBoxUser=${epikBoxUser}&numId=${numId}`,
      body,
      { headers },
    );
    return data;
  }

  async getNumberAssignmentLog(numberID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/numbers/${numberID}/number-log`,
      { headers },
    );
    return data;
  }

  async forceUnlinkNumberFromBox(numId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/numbers/${numId}/force-unlink`,
      {},
      { headers },
    );
    return data;
  }

    // .post /:id/AgreementFile',
    async uploadAgreementFile(id, files) {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
  
      try {
        const { data } = await axios.post(
          `${this.getBaseURL(global.vmail)}${apiVersion}/numbers/${id}/agreement`,
          files,
          { headers },
        );
        const downloadURL = data.downloadURL;
        console.log("Uploaded file details:", files);
  
        return downloadURL;
      } catch (error) {
        console.error("File upload failed:", error);
        throw error;
      }
    }
  
    // .get /AgreementFile',
    async downloadAgreementFile(id) {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
  
      try {
        // Perform the GET request to download the file
        const response = await axios.get(
          `${this.getBaseURL(global.vmail)}${apiVersion}/numbers/${id}/agreement/download`,
          {
            headers,
            responseType: 'blob',
          }
        );
        return response.data;
      } catch (error) {
        console.error("File download failed:", error);
        throw error;
      }
    }
    async getObiCallerOverRide(id,targetCallerId,overrideFlags) {
      if (this.demo) {
        return Promise.resolve([]);
      }
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.put(
        `${this.getBaseURL()}${apiVersion}/boxes/${id}/BoxObi`,
        {
          targetCallerId,
          overrideFlags
        },
        {
          headers,
        }
      );
      return data;
    }  
}

export default NumberService;
